import Vue from 'vue'
import { Request } from "../../utils/requests"

export default {
    updateActiveOrganisation({commit, dispatch}, organisation) {
        commit('UPDATE_ACTIVE_ORGANISATION', organisation)
        dispatch('loadDPRReports')
    },
    updateOrganisationUser({commit}, user) {
        commit('UPDATE_ORGANISATION_USER', user)   
    },
    loadDPRReports({ commit, rootState }) {
        Request(this, 'GET', rootState.apiendpoints.dpr_reports, {is_active: 'true', limit: 100, offset: 0}).then(
            res => {
                commit('UPDATE_AVAILABLE_REPORTS', res.results)
            },
            err => {
                commit('UPDATE_AVAILABLE_REPORTS', [])
                console.error("Error in fetching reports!", err)
            }
        )
    },
    setUnreadNotification({commit}, unread_notifications) {
        commit('SET_UNREAD_NOTIFICATIONS', unread_notifications)
    },
    updateUnreadNotification({commit}) {
        commit('UPDATE_UNREAD_NOTIFICATIONS')
    },
}
